import React, { useState, useEffect } from "react";
import styles from "./Splash.module.css";
// icons
import GMallLogo from "../../../assets/images/data/gmall-logo.png";
import Welcome from "./Welcome/Welcome";

const Splash = () => {
  const [splashState, setSplashState] = useState(0);
  const [showWelcome, setShowWelcome] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setSplashState(1);
    }, 500);
    setTimeout(() => {
      setSplashState(2);
      setShowWelcome(true);
    }, 3000);
    setTimeout(() => {
      setSplashState(3);
    }, 4000);
  }, []);

  return (
    <>
      {/* <div
        className={`${styles.SplashScreen} ${
          splashState >= 2 ? styles.Hide : ""
        } ${splashState >= 3 ? styles.Delete : ""}`}
      >
        <img
          className={`${styles.GMall} ${splashState >= 1 ? styles.Show : ""}`}
          src={GMallLogo}
          alt="splash logo"
        />
      </div> */}
      {/* {showWelcome && localStorage.getItem("welcome") !== "true" && (
        <Welcome show={showWelcome} setShow={setShowWelcome} />
      )} */}
    </>
  );
};

export default Splash;
